import { createRoot } from "react-dom/client";
import { ChainPay } from "@/pages/components/ChainPay";
import i18n from "@/i18n";
import { ChainPayProps } from "@/index";

import "@/index.css";

export const useChainPay = (options: ChainPayProps) => {
  let root: any;
  let container: any;

  const closePayModal = () => {
    try {
      if (root) {
        root.unmount();
        root = null;
      }
    } catch (error) {
      console.warn("ChainPay: Error unmounting root:", error);
    }

    try {
      if (container && container.parentNode) {
        container.parentNode.removeChild(container);
        container = null;
      }
    } catch (error) {
      console.warn("ChainPay: Error removing container:", error);
    }
  };

  const showPayModal = (modalOptions: ChainPayProps) => {
    // 检查是否在客户端环境
    if (typeof window === "undefined" || typeof document === "undefined") {
      console.warn(
        "ChainPay: showPayModal can only be called in browser environment"
      );
      return;
    }

    // 检查是否在Next.js SSR环境中
    if (typeof window !== "undefined" && !window.document) {
      console.warn(
        "ChainPay: Document not available, waiting for client hydration"
      );
      return;
    }

    try {
      // 设置语言
      i18n.changeLanguage(options.language as string);

      // 创建容器
      container = document.createElement("div");

      // 创建根节点 - 添加错误处理
      root = createRoot(container);

      // 渲染组件
      root.render(
        <ChainPay
          {...{ ...options, ...modalOptions }}
          onClose={() => {
            (modalOptions.onClose || options.onClose)?.();
            closePayModal();
          }}
        />
      );
    } catch (error) {
      console.error("ChainPay: Error creating payment modal:", error);
      // 清理可能创建的容器
      if (container && container.parentNode) {
        container.parentNode.removeChild(container);
      }
    }
  };

  return {
    showPayModal,
    closePayModal,
  };
};

export default useChainPay;
